import { onKeyStroke } from '@vueuse/core';
import { isAssistantShortcut } from '@/domain/assistant/assistant-shortcut';

/** Open dialogs that own the keyboard (vue-js-modal, Vuetify dialogs). */
const BLOCKING_DIALOGS = '.vm--container, .v-dialog--active';

export interface IAssistantShortcutOptions {
  /** The pill shows: the rollout, the store and the route allow the panel. */
  available: () => boolean;
  isOpen: () => boolean;
  open: () => void;
  close: () => void;
  /** The focus is inside the panel (a field inside the widget counts). */
  containsFocus: () => boolean;
  /** Moves the focus to the composer (to the panel while the widget loads). */
  focusComposer: () => void;
}

/**
 * Ctrl/⌘+K (plan §9.4): opens the panel; while it is open, closes it when
 * the focus is inside it and otherwise brings the focus to the composer. An
 * explicit chord, so it also works while typing in a page field or in the
 * widget (its key events are composed). Returns the stop function.
 */
export function useAssistantShortcut(
  options: IAssistantShortcutOptions
): () => void {
  return onKeyStroke(
    (event) => isAssistantShortcut(event),
    (event) => {
      if (
        event.defaultPrevented ||
        !options.available() ||
        typeof document === 'undefined' ||
        document.querySelector(BLOCKING_DIALOGS)
      )
        return;
      event.preventDefault();
      if (!options.isOpen()) options.open();
      else if (options.containsFocus()) options.close();
      else options.focusComposer();
    },
    {
      target: () => (typeof window === 'undefined' ? undefined : window),
      dedupe: true,
    }
  );
}
